<template>
  <div>
    <!-- 退出弹框 -->
    <modalDefault
      :showModal="showModal"
      @close="close()"
      @confirm="confirm()"
      modalText="退出登录"
    >
      <template #dialogContent>
        <div class="buy-box">
          <span>退出当前账号？</span>
        </div>
      </template>
    </modalDefault>
  </div>
</template>
<script>
import modalDefault from "@/components/common/modalDefault.vue";
export default {
  name: "modalLogout",
  components: {
    modalDefault,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
<style>
</style>